import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Logo } from "@/components/site/Navbar";
import { ThemeToggle } from "@/components/site/ThemeToggle";
import { api, formatErr } from "@/lib/api";

export default function SetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters.");
    if (pw !== confirm) return toast.error("Passwords don't match.");
    setBusy(true);
    try {
      await api.post("/auth/set-password", { token, password: pw });
      toast.success("Password set! You can sign in now.");
      nav("/login");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col p-6 sm:p-12" data-testid="set-password-page">
      <div className="flex items-center justify-between max-w-5xl w-full mx-auto"><Logo /><ThemeToggle /></div>
      <form onSubmit={submit} className="m-auto w-full max-w-sm space-y-5 py-12" data-testid="set-password-form">
        <div className="h-14 w-14 rounded-2xl bg-primary/15 grid place-items-center"><KeyRound className="h-6 w-6 text-primary" /></div>
        <h1 className="text-3xl font-bold">Create your password</h1>
        <p className="text-muted-foreground">Welcome to the network. Choose a password for your member portal.</p>
        {!token && <p className="text-sm text-destructive" data-testid="set-password-missing-token">This link is missing its token. Please use the link from your email.</p>}
        <Input required type="password" placeholder="New password (8+ characters)" value={pw} onChange={(e) => setPw(e.target.value)} className="h-12 rounded-xl" data-testid="set-password-input" />
        <Input required type="password" placeholder="Confirm password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="h-12 rounded-xl" data-testid="set-password-confirm-input" />
        <button disabled={busy || !token} className="w-full h-12 rounded-full bg-primary text-primary-foreground font-bold btn-glow inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="set-password-submit-button">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Set password
        </button>
        <p className="text-sm text-muted-foreground"><Link to="/login" className="font-bold text-primary">Back to sign in</Link></p>
      </form>
    </div>
  );
}
